import { o as otto } from "../chunks/nexus-client-client-TGyNJoMo.mjs";
const wishlist = otto.wishlist;
const addItem = wishlist.addItem;
const deleteItem = wishlist.deleteItem;
const setAvailabilityAlertStatus = wishlist.setAvailabilityAlertStatus;
export {
  addItem,
  deleteItem,
  setAvailabilityAlertStatus,
  wishlist
};
/*                                     */
